class s {
  static variantSelected = "variant:selected";
  static variantUpdate = "variant:update";
  static cartUpdate = "cart:update";
  static cartError = "cart:error";
  static mediaStartedPlaying = "media:started-playing";
  static quantitySelectorUpdate = "quantity-selector:update";
  static megaMenuHover = "megaMenu:hover";
  static zoomMediaSelected = "zoom-media:selected";
  static discountUpdate = "discount:update";
  static FilterUpdate = "filter:update";
}
class u extends Event {
  constructor(t) {
    (super(s.variantSelected, { bubbles: !0 }), (this.detail = { resource: t }));
  }
}
class o extends Event {
  constructor(t, a, e) {
    (super(s.variantUpdate, { bubbles: !0 }),
      (this.detail = {
        resource: t || null,
        sourceId: a,
        data: { html: e.html, productId: e.productId, newProduct: e.newProduct },
      }));
  }
}
class c extends Event {
  constructor(t, a, e) {
    (super(c.eventName, { bubbles: !0 }),
      (this.detail = { resource: t, sourceId: a, data: { ...e } }));
  }
  static eventName = s.cartUpdate;
}
class l extends Event {
  constructor(t, a, e) {
    (super(s.cartUpdate, { bubbles: !0 }),
      (this.detail = { resource: t, sourceId: a, data: { ...e } }));
  }
}
class p extends Event {
  constructor(t, a, e, i) {
    (super(s.cartError, { bubbles: !0 }),
      (this.detail = { sourceId: t, data: { message: a, errors: i, description: e } }));
  }
}
class d extends CustomEvent {
  constructor() {
    super(d.eventName);
  }
  static eventName = "dialog:open";
}
class n extends CustomEvent {
  constructor() {
    super(n.eventName);
  }
  static eventName = "dialog:close";
}
export { l as C, d as D, s as T, u as V, o as a, p as b, c, n as d };
